import React from 'react';
//material
import {Container, Grid, List, ListItem, ListItemText, ListItemIcon } from '@material-ui/core';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
//components
import PersonalInfo from '../../../components/profile/personal-info-card';
import Password from '../../../components/profile/password-card';
import Socials from '../../../components/profile/social-media-card';
import Avatar from '../../../components/profile/avatar-card';
import Handicap from '../../../components/profile/handicap-card';

const ProfileView = (props) => {
  const {isLoading, settings} = props;

  return (
    <Container maxWidth={'md'}>
      <Grid container>
        <Grid item xs={12} sm={12} md={4}>
          <List component="nav" aria-label="profile options">
            <ListItem button>
              <ListItemIcon>
                <AccountCircleIcon />
              </ListItemIcon>
              <ListItemText primary="Account Info"/>
            </ListItem>
          </List>
        </Grid>
        <Grid item xs={12} sm={12} md={8} >
          <h1>Account Info</h1>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12}>
              <Avatar />
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <PersonalInfo />
            </Grid>

            {
              !isLoading && settings.playerCanUpdateHandicap &&
              <Grid item xs={12} sm={12} md={12}>
                <Handicap />
              </Grid>
            }

            <Grid item xs={12} sm={12} md={12}>
              <Password />
            </Grid>
            <Grid item xs={12} sm={12} md={12}>
              <Socials />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  )
};

export default ProfileView;
